import * as React from 'react';
import { SketchPicker } from 'react-color';

import Dropdown, { DropdownProps } from 'antd/es/dropdown';

import '@common/react/scss/components/colorPicker.scss';

const getDashboardContainer = () => document.getElementById('dashboardContainer') || document.body;

export enum ColorPickerMode {
	VIEW,
	EDIT
}

export interface ColorPickerProps {
	mode: ColorPickerMode;
	color: string;
	onChange?: (color: any, event: MouseEvent) => void;
	width?: number;
	className?: string;
	label?: string;
	asCheckbox?: boolean;
	dropdownProps?: Partial<DropdownProps>;
}

const ColorPicker: React.FC<ColorPickerProps> = (props) => {
	const {
		width = '100%',
		color,
		className = '',
		mode,
		onChange,
		asCheckbox,
		dropdownProps,
		label,
	} = props;
	const [displayColorPicker, setDisplayColorPicker] = React.useState(false);

	const handleClose = () => {
		setDisplayColorPicker(false);
	};

	if (mode === ColorPickerMode.EDIT) {
		return (
			<div className={asCheckbox ? 'color-picker-as-checkbox color-picker_edit' : ''}>
				<Dropdown
					destroyPopupOnHide
					placement="bottomLeft"
					classNames={{ root: 'color-picker__popover' }}
					getPopupContainer={getDashboardContainer}
					{...dropdownProps}
					open={displayColorPicker}
					onOpenChange={(visible) => setDisplayColorPicker(visible)}
					trigger={['click']}
					menu={{
						items: [{
							key: 1,
							label: <div style={{ margin: '-9px -16px' }}>
								<div className="color-picker__cover" onClick={handleClose} />
								<SketchPicker
									color={color || '#fff'}
									onChangeComplete={onChange}
								/>
							</div>,
						}],
					}}
				>
					<div className="color-picker__trigger">
						{label && <label style={{ cursor: 'pointer' }}>{label}</label>}
						<div className={`color-picker__color-container ${className}`} style={{ width }}>
							<div className="color-picker__color-container-inner" style={{ backgroundColor: color }} />
						</div>
					</div>
				</Dropdown>
			</div>
		);
	}

	return (
		<div className={asCheckbox ? 'color-picker-as-checkbox color-picker_view' : ''}>
			{label && <label>{label}</label>}
			<div className={`color-picker__color-container ${className}`} style={{ width }}>
				<div className="color-picker__color-container-inner" style={{ backgroundColor: color }} />
			</div>
		</div>
	);
};

export default ColorPicker;
